import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorAction, ErrorConfig, ErrorActionId } from 'src/app/models/interfaces/error.interfaces';

type ErrorDialogResult = { actionId: ErrorActionId };

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ErrorDialogComponent, ErrorDialogResult>,
        @Inject(MAT_DIALOG_DATA) public data: { config: ErrorConfig }
    ) { }

    onAction(action: ErrorAction): void {
        this.dialogRef.close({ actionId: action.id });
    }

    onCancel(): void {
        this.dialogRef.close({ actionId: 'CLOSE' });
    }

    getIcon(): string {
        switch (this.data.config.type) {
            case 'warning':
                return 'warning';
            case 'info':
                return 'info';
            case 'error':
            default:
                return 'error';
        }
    }
}
